/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_ErrorsInputs */



/**
* | output |
* | --- |
* | "Errors" |
*
* @param {Options_Quicktools_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_errors = /** @type {((inputs?: Options_Quicktools_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erros")
	return /** @type {LocalizedString} */ ("Errors")
});